export { default as RdsIcon } from './Icon';
export * from './Icon.interface';
